export default {
  app: {
    notFound: {
      title: 'Az oldal nem található.',
      subtitle: 'Úgy tűnik, eltévedtél.',
      text: 'Ne aggódjon, mi segítünk eligazodni innen',
    },
  },
};
